import { render, staticRenderFns } from "./distributionBatchIndex.vue?vue&type=template&id=fbf9cf96&scoped=true&"
import script from "./distributionBatchIndex.vue?vue&type=script&lang=js&"
export * from "./distributionBatchIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf9cf96",
  null
  
)

export default component.exports